import React, { useState } from 'react';

function Develop() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  

  return (
    <section id="gis" className="gis-section">
      <h2 class="section-title">Обработка пространственных данных</h2>
      <div className="accordion">
        <p className='component-base'> Мы предлагаем вам наш колоссальный опыт работы с геопространственными данными,
           их сбор, обработку, приведение к топологической целостности, а также весь спектр пространственного анализа.
            Грамматно построенные пространственные данные помогут выявить закономерности в различных сферах деятельности и принять верное решение для бизнеса.
             Результаты анализа визуализируются с помощью карт и графиков, что делает их более понятными для конечных пользователей.</p>
       
        <div className="image-gallery" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <img src="/images/gismonitor.png" alt="gismonitor" style={{ width: '32%' }} />
        <img src="/images/gisfile.png" alt="gisfile" style={{ width: '32%' }} />
        <img src="/images/gischart.png" alt="gischart" style={{ width: '32%' }} />
      </div>
      </div>
      
    </section>
  );
}

export default Develop;

